import { render, staticRenderFns } from "./PaneInfo.vue?vue&type=template&id=d8df6de4&scoped=true"
import script from "./PaneInfo.vue?vue&type=script&lang=js"
export * from "./PaneInfo.vue?vue&type=script&lang=js"
import style0 from "./PaneInfo.vue?vue&type=style&index=0&id=d8df6de4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8df6de4",
  null
  
)

export default component.exports